import { useEffect, useRef, useState } from "react";
import { releaseImageAssetMap } from "../../Lib/markdownImages.js";
import { restoreImageAssets } from "../../Lib/imageAssetStore.js";

const useImageAssets = () => {
  const [assets, setAssets] = useState({});
  const assetsRef = useRef(assets);

  useEffect(() => {
    let disposed = false;
    restoreImageAssets().then(restoredAssets => {
      if (disposed) {
        releaseImageAssetMap(restoredAssets);
        return;
      }
      setAssets(previousAssets => ({ ...previousAssets, ...restoredAssets }));
    });
    return () => {
      disposed = true;
    };
  }, []);

  useEffect(() => {
    assetsRef.current = assets;
  }, [assets]);

  useEffect(
    () => () => releaseImageAssetMap(assetsRef.current),
    []
  );

  const updateAssets = nextAssets => {
    setAssets(previousAssets => {
      const next =
        typeof nextAssets === "function"
          ? nextAssets(previousAssets)
          : nextAssets;
      const nextUrls = new Set(Object.values(next || {}));
      for (const url of new Set(Object.values(previousAssets || {}))) {
        if (!nextUrls.has(url)) URL.revokeObjectURL(url);
      }
      return next;
    });
  };

  return [assets, updateAssets];
};

export default useImageAssets;
